const styles = () => ({
  header: {
    display: 'flex',
  },

  link: {
    fontSize: '15px',
    color: '#5786D7',
    textDecoration: 'none',
    cursor: 'pointer',
  },

  spacer: {
    flex: '1 1 auto',
  },

  label: {
    fontSize: 15,
    color: '#A9B0B8',
  },

  embed: {
    display: 'block',
    border: 'none',
    height: 173,
    background: '#FFFFFF',
    boxShadow: '0 1px 3px 0 rgba(230,230,232,0.80)',
    borderRadius: 6,
    position: 'relative',
  },

  embedTextarea: {
    border: 'none',
    display: 'block',
    width: '100%',
    height: '100%',
    background: 'transparent',
    outline: 'none',
    resize: 'none',
    color: '#A8B1C0',
    fontWeight: 500,
    fontFamily: ['Monaco', 'consolas', 'monospace'],
    fontSize: 13,
    lineHeight: '23px',
  },
});

export default styles;
